import { cn } from '@heidi/utils';

import { menuItemVariants, menuLabelClasses, menuSeparatorClasses } from '../styles';

import type { DropdownMenuItemProps } from './dropdown-menu.types';

/**
 * Experimental DropdownMenu styles (DS-1195) — the shared menu recipe
 * (`menuItemVariants` / `menuLabelClasses` / `menuSeparatorClasses`), gated behind
 * `release-experimental-design-system-forms`. Item = 32px / `rounded-md`,
 * concentric with the content surface (`rounded-lg` + `p-1`).
 */

/**
 * `group/dropdown-menu-item` is re-applied here: `DropdownMenuShortcut` and
 * `DropdownMenuItemDescription` target `group-hover/…` / `group-focus/…`, and the
 * shared recipe is deliberately group-agnostic.
 */
export const dropdownMenuItemVariantsExperimental = ({
  variant,
  inset,
  selected,
}: Pick<DropdownMenuItemProps, 'variant' | 'inset' | 'selected'>) =>
  cn(
    'group/dropdown-menu-item',
    menuItemVariants({ variant: selected ? 'selected' : variant, inset })
  );

export const dropdownMenuSubTriggerClassesExperimental = cn(
  menuItemVariants(),
  'data-[state=open]:bg-surface-hover data-[state=open]:text-text-primary'
);

/** Keeps the trailing (`end-2`) check/radio indicator; height/radius come from the recipe. */
export const dropdownMenuCheckItemClassesExperimental = cn(
  menuItemVariants(),
  'pe-8 [&>span]:pointer-events-none [&>span]:end-2 [&>span]:start-auto'
);

export const dropdownMenuLabelClassesExperimental = menuLabelClasses;

export const dropdownMenuSeparatorClassesExperimental = menuSeparatorClasses;
